/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import _has from 'lodash/has';
import _set from 'lodash/set';
import * as sdkToUI from '../../adapter/style-adapters/sdk-ui';
import * as uiToSdk from '../../adapter/style-adapters/ui-sdk';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { canvasToEmu } from '@src/slide/infrastructure/module/independent/unit';
import {
    getFrameAfterRotate,
    checkChildrenNeedChangeWidthHeight,
} from '@src/slide/infrastructure/module/independent/graphic';
import BaseConvert from './baseConvert';
import StyleConvert from './styleConvert';
import { enumerateGroup } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';

const MedaiLinkAction = 'ppaction://media';

export default class ElementBaseConvert extends BaseConvert {
    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static convertDataSdkToUi(sdkData, uiData, csData) {
        super.convertDataSdkToUi(sdkData, uiData, csData);

        ElementBaseConvert.mobxSetLink(sdkData, uiData);
        ElementBaseConvert.mobxSetAddon(sdkData, uiData);

        // 样式convert
        StyleConvert.convertDataSdkToUi(sdkData, uiData, csData);
    }

    /**
     *
     * @param uiData
     * @param sdkData
     * @param rawUiModel
     */
    public static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        super.convertDataUiToSdk(uiData, sdkData, rawUiData);
        const scale = {
            scaleX: 1.0,
            scaleY: 1.0,
        };

        const offsetPosition = {
            left: 0,
            top: 0,
        };

        ElementBaseConvert.checkInParentU2S(rawUiData, scale, offsetPosition);
        const { flip, adjustFrame } = ElementBaseConvert.propsStyleSet(uiData, sdkData, rawUiData);
        // 插入placeholder时不要frame，从master 继承

        ElementBaseConvert.propsFrameSet(uiData, adjustFrame, sdkData, offsetPosition, flip, rawUiData, scale);

        if (_has(uiData, 'props.style.placeholder.type')) {
            _set(sdkData, 'props.placeholder.type', uiData.props.style.placeholder.type);
        }
        if (_has(uiData, 'props.style.placeholder.index')) {
            _set(sdkData, 'props.placeholder.index', uiData.props.style.placeholder.index);
        }

        if (_has(uiData, 'props.link')) {
            const linkData = uiToSdk.convertLink(uiData.props.link);
            _set(sdkData, 'props.hlink', linkData.hlink ? linkData.hlink : null);
        }

        if (_has(uiData, 'props.addon')) {
            const iframeData = uiToSdk.convertAddon(uiData.props.addon);
            _set(sdkData, 'props.addon', iframeData ? iframeData : null);
        }

        if (_has(uiData, 'props.useBgFill')) {
            _set(sdkData, 'useBgFill', uiData.props.useBgFill);
        }

        // 样式convert
        StyleConvert.convertDataUiToSdk(uiData, sdkData);
    }

    protected static convert3DDataUiToSdk(uiData, sdkData) {
        uiToSdk.convertScene3D(uiData, sdkData);
        uiToSdk.convertShape3D(uiData, sdkData);
    }

    protected static convert3DDataSdkToUi(sdkData, uiData) {
        sdkToUI.convertScene3D(sdkData, uiData);
        sdkToUI.convertShape3D(sdkData, uiData);
    }

    private static checkInParentU2S(rawUiData, scale, offsetPosition) {
        // 检查是否在节点上.
        if (rawUiData.parent) {
            enumerateGroup(rawUiData, (groupModel) => {
                scale.scaleX *= groupModel.scaleX;
                scale.scaleY *= groupModel.scaleY;
            });

            if (rawUiData.parent?.type === UIModelType.GROUP) {
                const parentChildFrame = rawUiData.parent.groupChildFrameChangedByChildren;
                if (parentChildFrame) {
                    offsetPosition.left = canvasToEmu(parentChildFrame.left);
                    offsetPosition.top = canvasToEmu(parentChildFrame.top);
                } else {
                    offsetPosition.left = rawUiData.parent.sdkData.props.frame.childOffsetLeft;
                    offsetPosition.top = rawUiData.parent.sdkData.props.frame.childOffsetTop;
                }
            }
        }
    }

    private static propsStyleSetUiDataJudge(uiData, rawUiData) {
        return (_has(uiData, 'props.style.left') || _has(uiData, 'props.style.rotate'))
        && (rawUiData.parent ? rawUiData.parent.type === UIModelType.GROUP : false);
    }

    private static propsStyleSet(uiData, sdkData, rawUiData) {
        // position
        let adjustFrame: any = null;
        let flip = false;
        if (uiData?.props?.style) {
            uiToSdk.addTransform(uiData.props.style, sdkData, 'props.frame');

            if (ElementBaseConvert.propsStyleSetUiDataJudge(uiData, rawUiData)) {
                const rotate = ElementBaseConvert.getRotate(uiData, rawUiData);
                const flipH = ElementBaseConvert.getFlipH(uiData, rawUiData);
                const flipV = ElementBaseConvert.getFlipV(uiData, rawUiData);

                if (checkChildrenNeedChangeWidthHeight(rotate, flipH, flipV)) {
                    flip = true;
                    if (typeof uiData?.props?.style.left !== 'undefined') {  // /正在修改rect， left\top\width\height会一起都传过来的
                        adjustFrame = getFrameAfterRotate(uiData.props.style, 90);
                    } else if (typeof rawUiData?.props?.style.left !== 'undefined') {  // /非正在编辑rect，则处理原始Rect数据
                        adjustFrame = getFrameAfterRotate(rawUiData.props.style, 90);
                    }
                }
            }
        }
        return { flip, adjustFrame };
    }
    private static getRotate(uiData, rawUiData) {
        let rotate = 0;
        if (_has(uiData, 'props.style.rotate')) { // /正在修改rotate属性
            rotate = uiData.props.style.rotate;
        } else if (_has(rawUiData, 'props.style.rotate') && rawUiData.props.style.rotate) { // /原始数据有没有rotate属性
            rotate = rawUiData.props.style.rotate;
        }
        return rotate;
    }
    private static getFlipH(uiData, rawUiData) {
        let flipH = 0;
        if (_has(uiData, 'props.style.flipH')) { // /正在修改flipH属性
            flipH = uiData.props.style.flipH;
        } else if (_has(rawUiData, 'props.style.flipH') && rawUiData.props.style.flipH) { // /原始数据有没有flipH属性
            flipH = rawUiData.props.style.flipH;
        }
        return flipH;
    }
    private static getFlipV(uiData, rawUiData) {
        let flipV = 0;
        if (_has(uiData, 'props.style.flipV')) { // /正在修改flipV属性
            flipV = uiData.props.style.flipV;
        } else if (_has(rawUiData, 'props.style.flipV') && rawUiData.props.style.flipV) { // /原始数据有没有flipV属性
            flipV = rawUiData.props.style.flipV;
        }
        return flipV;
    }

    private static propsFrameSet(uiData, adjustFrame, sdkData, offsetPosition, flip, rawUiData, scale) {
        if (!(_has(uiData, 'props.style.placeholder.reset') && uiData.props.style.placeholder.reset)) {
            if (adjustFrame) {
                _set(sdkData, 'props.frame.left', canvasToEmu(adjustFrame.left / scale.scaleX) + offsetPosition.left);
                _set(sdkData, 'props.frame.top', canvasToEmu(adjustFrame.top / scale.scaleY) + offsetPosition.top);
                _set(sdkData, 'props.frame.width', canvasToEmu(adjustFrame.width) / scale.scaleX);
                _set(sdkData, 'props.frame.height', canvasToEmu(adjustFrame.height) / scale.scaleY);
            } else {
                if (_has(uiData, 'props.style.left')) {
                    _set(sdkData, 'props.frame.left', canvasToEmu(uiData.props.style.left / scale.scaleX) + offsetPosition.left);
                }

                if (_has(uiData, 'props.style.top')) {
                    _set(sdkData, 'props.frame.top', canvasToEmu(uiData.props.style.top / scale.scaleY) + offsetPosition.top);
                }

                if (_has(uiData, 'props.style.width')) {
                    _set(sdkData, 'props.frame.width', canvasToEmu(uiData.props.style.width) / scale.scaleX);
                }

                if (_has(uiData, 'props.style.height')) {
                    _set(sdkData, 'props.frame.height', canvasToEmu(uiData.props.style.height) / scale.scaleY);
                }
            }
        }

        ElementBaseConvert.handleGroupElementFrame(rawUiData, sdkData, flip);
    }

    private static handleGroupElementFrame(rawUiData, sdkData, flip) {
        if (rawUiData.parent && rawUiData.parent.type === UIModelType.GROUP) {  // /正在更新frame时才加这个，否则会影响removeProps
            if (flip) {
                let eleFrame = sdkData.props.frame;
                eleFrame = getFrameAfterRotate(eleFrame, -90);
                // /Group element 如果有rotate flip， 再计算scale后的 Width 和 Height,  然后再把element的水平属性给把数据转回去
                _set(sdkData, 'props.frame.height', eleFrame.height);
                _set(sdkData, 'props.frame.width', eleFrame.width);
                _set(sdkData, 'props.frame.top', eleFrame.top);
                _set(sdkData, 'props.frame.left', eleFrame.left);
            }
        }
    }

    private static mobxSetAddon(sdkData, uiData) {
        if (_has(sdkData, 'props.addon')) {
            const iframeData = sdkToUI.convertAddon(sdkData.props.addon);
            _set(uiData, 'props.addon', iframeData ? iframeData : null);
        } else {
            _set(uiData, 'props.addon', null);
        }
    }

    private static mobxSetLink(sdkData, uiData) {
        // 音视频不支持链接设置，link是播放多媒体，因此此处不添加link属性
        if (_has(sdkData, 'props.hlink') && !this.isMediaLink(sdkData, sdkData.props.hlink)) {
            const linkData = sdkToUI.convertLink(sdkData.props);
            _set(uiData, 'props.link', linkData.href ? linkData : null);
        } else {
            _set(uiData, 'props.link', null);
        }
    }

    private static isMediaLink(sdkData, hlink) {
        return _has(sdkData, 'video') || _has(sdkData, 'audio') || hlink?.slideJump?.action === MedaiLinkAction;
    }
}

